<template>
  <div class="old-report">
    <a class="btn btn-outline mb-2" target="_blank" :href="link">Clique aqui para baixar o relatório</a>
    <button class="btn btn-primary" @click="$router.back()">Voltar</button>
  </div>
</template>

<script>
  export default {
    computed: {
      link() {
        return `https://platform.bkps.com.br${this.$route.fullPath}`
      }
    },
    name: 'OldDownload'
  }
</script>

<style scoped>
  .old-report {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-content: center;
    width: 50%;
    margin-left: 25%;
    margin-top: 100px;
    text-align: center;
  }
</style>